module.exports = __webpack_public_path__ + "gp.svg?b1feb2ba7f7335aacabda4fbc0ce012d";